export const enrollSteps = [
  {
    name: 'You',
  },
  {
    name: 'Documents',
  },
  {
    name: 'Contact',
  },
  {
    name: 'Eligibility',
  },
  {
    name: 'Location',
  },
  {
    name: 'Complete',
  },
]

export const renewalSteps = [
  {
    name: 'Eligibility',
  },
  {
    name: 'Contact',
  },
  {
    name: 'Pay',
  },
  {
    name: 'Complete',
  },
]
